// Recovered compiled webpack factory 21767. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { K: () => s });
  var n = i(10883);
  function s(t, e, i) {
    let s = t.getProps();
    return (0, n.a)(s, e, void 0 !== i ? i : s.custom, t);
  }
}
